import React, { FunctionComponent } from 'react';
import styles from './Dropdown.module.scss';
import { Dropdown as SemanticDropdown } from 'semantic-ui-react'
import { Activity } from '../../features/activities/list/activitiesListAppState';

export interface DropdownProps  { 
    placeholder: string;
    dark?: boolean;
    options: DropdownOptions[];
    onChange(event: any, data: any): void;
    value: string;
    staticText?: string;
    selection?: boolean;
    fluid?: boolean;
    search?: boolean;
    disabled?: boolean;
    inline?: boolean;
    id?: string;
    className?: string;
    'aria-label'?: string;
    searchInput?: { 'aria-label': string } | React.ReactNode;
}

export interface DropdownOptions {
    key: string;
    text: string;
    value: string;
    item?: Activity;
    translation?: string | string[];
}

export const Dropdown: FunctionComponent<DropdownProps> = ({dark, placeholder, staticText, onChange, options, value, selection, fluid, search = true, disabled, inline, className = '', 'aria-label': ariaLabel, searchInput, ...rest}) => {
    // If search is enabled and aria-label is provided but no searchInput, create searchInput with aria-label
    const computedSearchInput = search && ariaLabel && !searchInput 
        ? { 'aria-label': ariaLabel }
        : searchInput;
    
    return (
        <SemanticDropdown
            text={staticText}
            className={`${styles.dropdown} ${dark ? styles.dark : ''} ${className}`}
            placeholder={placeholder}
            options={options}
            onChange={onChange}
            value={value}
            selection={selection}
            fluid={fluid}
            search={search}
            disabled={disabled}
            inline={inline}
            aria-label={ariaLabel}
            searchInput={computedSearchInput}
            {...rest}
        />
    );
}

Dropdown.defaultProps = {
    selection: true,
    fluid: true,
    dark: false,
    disabled: false
};